module.exports = __webpack_public_path__ + "img/7.77cddca2.png";